// @flow
import React, {useEffect, useMemo, useState} from 'react';
import {useTranslation} from "react-i18next";
import DataGridWrapper from "../../../../../components/dataGridWrapper/dataGridWrapper";
import {DataGridPremium, GRID_AGGREGATION_ROOT_FOOTER_ROW_ID, GridActionsCellItem} from '@mui/x-data-grid-premium';
import {USERS} from "../../../locales/namespaces";
import {muiGridLocales} from "../../../../../helpers/muiGridLocales";
import {useMuiGridServerSide} from "../../../../../hooks/useMuiGridServerSide";
import moment from "moment";
import {CustomPagination} from "../../../../../components/dataGridCustom/customPagination";
import {Button, Tooltip} from "@mui/material";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import useUserData from "../../../../../hooks/user/useUserData";
import {API} from "../../../../../helpers/constants";
import axios from "axios";
import {enqueueSnackbar} from "notistack";
import {handleAxiosErrors} from "../../../../../helpers/errorHandling";
import ContentLoader from "../../../../../components/contentLoader/contentLoader";

const HistoryLoginTable = (props) => {
    const [loading, setLoading] = useState(false)
    const {t} = useTranslation(USERS)
    const {token} = useUserData()
    const url = `user/logs/data`

    const {
        isLoading,
        data,
        total,
        page,
        pageSize,
        onPaginationModelChange,
        onSortModelChange,
        onFilterModelChange,
        refreshGrid
    } = useMuiGridServerSide({
        url,
        initialPageSize: 50,
        initialSortModel: [{name: 'id', direction: 'descending'}],
    })

    const handlePdf = (params)=>{
        setLoading(true)
        axios({
            method: 'get',
            headers: {'Content-Type': 'application/json', 'Authorization': `Bearer ${token}`},
            url: `${API}/user/logs/file/${params.row.logid}`,
            responseType: 'blob'
        }).then(response => {
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);

            // Create a link element
            const a = document.createElement('a');
            a.href = url;
            a.download = 'downloaded.pdf'; // Set the filename for download
            a.target = '_blank'; // Open in a new tab
            a.style.display = 'none';

            // Append the link element to the document and trigger the click event
            document.body.appendChild(a);
            a.click();

            // Open a new tab with the PDF
            window.open(url, '_blank');

            // Clean up by revoking the blob URL
            window.URL.revokeObjectURL(url);

            enqueueSnackbar(t('Successfully downloaded PDF!'), {
                variant: 'success',
                autoHideDuration: 1000,
            });
            setLoading(false)
        }).catch(error => {
            enqueueSnackbar(handleAxiosErrors(error, t('There is not a pdf to download!'), {
                    variant: 'error',
                }
            ))
            setLoading(false)
        }).catch(error =>{
            enqueueSnackbar(handleAxiosErrors(error, t('Failed to download PDF!'), {
                    variant: 'error',
                }
            ))
            setLoading(false)
        })
    }


    const columns = useMemo(() => [
        {
            field: 'LoginName',
            headerName: t('Login Name'),
            minWidth: 160, flex: 1,
        },
        {
            field: 'username',
            headerName: t('User Name'),
            minWidth: 160, flex: 1,
        },
        {
            field: 'date',
            headerName: t('Date'),
            minWidth: 160, flex: 1,
            type: 'date',
            valueFormatter: params => params?.value ? moment(params?.value).format("DD-MM-YYYY , HH:mm") : '',
            aggregable: false,
        },
        {
            field: 'status',
            headerName: t('Login Status'),
            minWidth: 160, flex: 1,
        },
        {
            field: 'type',
            headerName: t('Request'),
            minWidth: 160, flex: 1,
        },
        {
            field: 'actions',
            headerName: t('Download Pdf'),
            type: 'actions',
            minWidth: 100,
            flex: 1,
            getActions: (params) => {
                if (params.id === GRID_AGGREGATION_ROOT_FOOTER_ROW_ID) {
                    return [];
                }
                return [
                    <GridActionsCellItem
                        component={Button}
                        onClick={()=> {
                            handlePdf(params)
                        }}
                        icon={
                            <Tooltip title={t('Download Pdf')}>
                                <PictureAsPdfIcon/>
                            </Tooltip>
                        }
                    />,
                ]
            }
        },
    ], [])

    return !loading ?(
            <DataGridWrapper sx={{
                mt: 1,
                //maxWidth: '800px',
                height: '400px'
            }}>
                <DataGridPremium
                    sx={{
                        bgcolor: 'background.paper', ".MuiDataGrid-aggregationColumnHeaderLabel": {
                            display: "none"
                        },
                        maxHeight: 650
                    }}
                    columns={columns}
                    density={'compact'}
                    rows={data}
                    getRowId={(row)=>row.logid}
                    pagination
                    paginationModel={{page, pageSize}}
                    paginationMode='server'
                    onPaginationModelChange={onPaginationModelChange}
                    rowCount={Number(total)}
                    rowsPerPageOptions={[5, 10, 15, 20, 50, 100]}
                    sortingMode="server"
                    onSortModelChange={(sortModel) => onSortModelChange(sortModel)}
                    filterMode='server'
                    onFilterModelChange={onFilterModelChange}
                    loading={isLoading}
                    localeText={muiGridLocales(t)}
                    slots={{
                        pagination: CustomPagination,
                    }}
                />
            </DataGridWrapper>
    ): (
        <ContentLoader
            loading={loading}
        />
    )
}

export default HistoryLoginTable